/* eslint-disable no-unused-vars */
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Scrollbars from 'react-custom-scrollbars-2';
import { useAuth } from '../../contexts/AuthContext';
import { defaultHomePath } from '../../lib/homePath';

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { canAccess, isAdmin, user, logout } = useAuth();

  const handleLogout = async (e) => {
    e.preventDefault();
    await logout();
    navigate('/login', { replace: true });
  };

  // Admin users see all modules; non-admin users see only modules they have access to
  const showModule = (moduleCode) => {
    if (isAdmin()) return true;
    return canAccess(moduleCode);
  };

  const isActive = (path, exact = false) => {
    if (exact) return location.pathname === path;
    if (path === '/insurance-companies') {
      return location.pathname.startsWith('/insurance');
    }
    if (path === '/claims') {
      return location.pathname.startsWith('/claims');
    }
    return location.pathname.startsWith(path);
  };

  const NavLink = ({ path, icon, label, exact }) => (
    <li>
      <Link to={path} className={isActive(path, exact) ? 'active' : ''}>
        <span className="menu-side">
          <i className={`fas ${icon}`} />
        </span>
        <span>{label}</span>
      </Link>
    </li>
  );

  return (
    <div className="sidebar" id="sidebar">
      <Scrollbars
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        autoHeight
        autoHeightMin={0}
        autoHeightMax="95vh"
        thumbMinSize={30}
        universal={false}
        hideTracksWhenNotNeeded
      >
        <div className="sidebar-inner slimscroll">
          <div id="sidebar-menu" className="sidebar-menu">
            <ul>
              <li className="menu-title">eCliniq</li>

              <NavLink path={defaultHomePath(user)} icon="fa-house-medical" label="Inicio" exact />

              {showModule('patients') && (
                <NavLink path="/patients" icon="fa-user-injured" label="Pacientes" />
              )}
              {(isAdmin() || showModule('admin')) && (
                <NavLink path="/doctors" icon="fa-user-md" label="Médicos" />
              )}
              {showModule('appointments') && (
                <NavLink path="/appointments" icon="fa-calendar-check" label="Citas" />
              )}
              {showModule('consultations') && (
                <NavLink path="/consultations" icon="fa-stethoscope" label="Consultas" />
              )}
              {showModule('surgery') && (
                <NavLink path="/surgery" icon="fa-kit-medical" label="Cirugías" />
              )}
              {showModule('surgery') && (
                <NavLink path="/surgeon-dashboard" icon="fa-kit-medical" label="Panel de Cirugía" />
              )}
              {showModule('billing') && (
                <NavLink path="/billing" icon="fa-file-invoice-dollar" label="Facturación" />
              )}
              {showModule('pharmacy') && (
                <NavLink path="/pharmacy" icon="fa-pills" label="Farmacia" />
              )}
              {showModule('imaging') && (
                <>
                <NavLink path="/imaging" icon="fa-x-ray" label="Imágenes" />
                <NavLink path="/imaging-viewer" icon="fa-microscope" label="Visor DICOM" />
                </>
              )}
              {showModule('reports') && (
                <NavLink path="/reports" icon="fa-chart-bar" label="Reportes" />
              )}
              {showModule('insurance') && (
                <>
                <NavLink path="/insurance-companies" icon="fa-shield-halved" label="Seguros" />
                <NavLink path="/claims" icon="fa-file-invoice" label="Reclamaciones" />
                </>
              )}
              <NavLink path="/pre-authorizations" icon="fa-file-shield" label="Pre-Autorizaciones" />
              {showModule('services') && (
                <NavLink path="/services" icon="fa-list-check" label="Servicios" />
              )}
              {(isAdmin() || showModule('admin') || showModule('settings')) && (
                <NavLink path="/clinic-settings" icon="fa-building" label="Mi Clínica" />
              )}

              {isAdmin() && (
                <>
                  <li className="menu-title">Administración</li>
                  <NavLink path="/admin/users"    icon="fa-users-gear"   label="Usuarios" />
                  <NavLink path="/ncf-sequences" icon="fa-receipt" label="Secuencias NCF" />
                  <NavLink path="/suppliers" icon="fa-truck" label="Proveedores" />
                  <NavLink path="/admin/profiles" icon="fa-id-card"      label="Perfiles" />
                  <NavLink path="/settings-management" icon="fa-gear"    label="Configuración" />
                </>
              )}
            </ul>

            <div className="logout-btn">
              <Link to="/login" onClick={handleLogout}>
                <span className="menu-side">
                  <i className="fas fa-right-from-bracket" />
                </span>
                <span>Cerrar Sesión</span>
              </Link>
            </div>
          </div>
        </div>
      </Scrollbars>
    </div>
  );
};

export default Sidebar;
